import { useMemo } from 'react'

import { Disclosure } from '@headlessui/react'
import { cx } from '@linaria/core'
import { SWRInfiniteResponse } from 'swr/infinite'

import { Dinner } from '~/api-definition/definition/dinner'
import { DinnersResponse } from '~/api-definition/response'
import { DinnerSummary } from '~/components/food_app/dinner/DinnerSummary'
import { dinnerIsOrganized } from '~/libs/dinner'
import { useSession } from '~/provider/SessionProvider'

export const DinnersDisclosure: React.FC<{
  showParticipationStatus: boolean
  titleText: string
  noContentText: string
  paginatedDinners: SWRInfiniteResponse<DinnersResponse>
  defaultOpen: boolean
}> = (props) => {
  const session = useSession({ loginRequired: true })

  const dinners = useMemo(() => {
    return props.paginatedDinners.data?.reduce((acc, cur) => {
      return [...acc, ...cur.dinners]
    }, [] as Dinner[])
  }, [props.paginatedDinners])

  return (
    <>
      <Disclosure defaultOpen={props.defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button
              className={cx(
                'relative flex w-full justify-between rounded-lg bg-[#E6E6EA] px-4 py-3 text-left text-sm font-medium',
                !open && 'mb-4'
              )}
            >
              <span>{props.titleText}</span>
              <div
                className={cx(
                  `absolute top-5 right-4 w-2 h-2 border-t border-t-black border-l`,
                  open && 'rotate-[45deg]',
                  !open && 'rotate-[225deg]'
                )}
              />
            </Disclosure.Button>
            <Disclosure.Panel className="py-4 text-sm text-gray-500">
              {dinners != null ? (
                dinners.map((dinner, i, arry) => {
                  return (
                    <div key={i}>
                      <DinnerSummary
                        showDate={true}
                        showParticipationStatus={props.showParticipationStatus}
                        showPrivacyTypeSelect={
                          session?.response &&
                          dinnerIsOrganized(
                            dinner,
                            session.response.data.userId
                          )
                        }
                        dinner={dinner}
                      />
                      <div
                        className={cx(
                          'w-full my-5',
                          i !== 0 && 'border-b border-gray'
                        )}
                      />
                    </div>
                  )
                })
              ) : (
                <></>
              )}
              {dinners != null &&
                props.paginatedDinners.data?.[0] != null &&
                props.paginatedDinners.data[0].paging.all > dinners.length && (
                  <div className="flex items-center justify-center my-2">
                    <button
                      onClick={() =>
                        props.paginatedDinners.setSize((s) => s + 1)
                      }
                      className="underline"
                      type="button"
                    >
                      もっと見る
                    </button>
                  </div>
                )}
              {dinners != null && dinners.length === 0 && (
                <div className="text-black text-sm pb-1">
                  <p>{props.noContentText}</p>
                </div>
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </>
  )
}
